import {
  Button,
  Card,
  ControlGroup,
  Elevation,
  Tag,
  Collapse,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost } from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import { withRouter } from "react-router";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import ItemInventoryLocationWidget from "./ItemInventoryLocationWidget";

class SxItems extends React.Component {
  state = {
    collapsed: true,
    /** PANEL SEARCH */
    panelSearching: false,
    panelSearchResults: [],
    panelSelectedItem: null,
    sxLineItemSearching: false,
    sxLineItemSearchResults: [],
    sxLineItemSelectedItem: null,
    isWaitingOnLineItem: false,
    items: [],
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = {
        prefix: string || "",
        showWhich: "CURRENT",
        itemCanBeSold: false,
        isOptical: false,
        isPharmacy: false,
        trySort: false,
        itemCategory: ["OT_CONSUMABLES", "IOL"],
      };
      let res = await apiCallPost(apiUrl, payload);
      let results = res;
      this.setState({
        [searchResArray]: results,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details."
      );
      console.log(err);
    }
  };
  renderAsyncSearchers = (
    tagText,
    placeHolderText,
    stateSearchingKey,
    stateSearchResultsKey,
    stateSelectedItemKey,
    searchApiUrl
  ) => {
    return (
      <ControlGroup>
        <Tag large minimal>
          {tagText}
        </Tag>
        <AsyncSelWrap
          disabled={this.props.isBusy || this.state.isWaitingOnLineItem}
          placeholder={placeHolderText}
          searching={this.state[stateSearchingKey]}
          items={this.state[stateSearchResultsKey].map((each) => {
            return {
              ...each,
              item: each.entityName,
              entityTypeString: `${each.itemNameSuffix}`,
            };
          })}
          selectedItem={null}
          update={(string) =>
            this.search(
              string,
              stateSearchResultsKey,
              stateSearchingKey,
              stateSelectedItemKey,
              searchApiUrl
            )
          }
          onChange={async (chosenItem) => {
            this.props.onUpdate({
              itemsNeededForSurgery: [
                ...this.props.data.itemsNeededForSurgery,
                chosenItem,
              ],
            });
          }}
        />
      </ControlGroup>
    );
  };
  renderItemSearch = () => {
    let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
    if (terminals.includes(this.props.data.lifecycle)) {
      return null;
    }
    return (
      <ControlGroup>
        {this.renderAsyncSearchers(
          "Add Surgical Items",
          "Items",
          "sxLineItemSearching",
          "sxLineItemSearchResults",
          "sxLineItemSelectedItem",
          `/ims2/${this.props.authStore.prefix}/item/search`
        )}
      </ControlGroup>
    );
  };
  renderAddedItems = () => {
    if (!this.props.data.itemsNeededForSurgery) {
      return null;
    }
    if (!this.props.data.itemsNeededForSurgery.length) {
      return (
        <ControlGroup>
          {" "}
          <Tag large intent="warning" minimal>
            No items added yet
          </Tag>
        </ControlGroup>
      );
    }
    let ii = this.props.data.itemsNeededForSurgery;
    return ii.map((each, index) => {
      return <ControlGroup>{this.renderEachItem(each, index)}</ControlGroup>;
    });
  };
  renderAgainstItem = (item) => {
    if (item.isShell) {
      return (
        <Tag intent="warning" icon="warning-sign">
          Shell Item
        </Tag>
      );
    }
    if (item.isItemService) {
      return (
        <Tag intent="warning" icon="warning-sign">
          Service Item
        </Tag>
      );
    }
    if (item.isItemGeneratorMother) {
      return (
        <Tag intent="warning" icon="warning-sign">
          Generator Mother Item. Please add a specific one from search, and
          remove this.
        </Tag>
      );
    } else {
      return (
        <ItemInventoryLocationWidget
          location={this.props.data.site}
          itemId={item._id}
          itemUnitName={item.itemUnitName}
        />
      );
    }
  };
  renderEachItem = (item, index) => {
    return (
      <ControlGroup>
        <Tag minimal large intent="primary">
          {index + 1}
        </Tag>
        <Tag large intent="primary">
          {item.itemNameSuffix ? (
            <>
              {item.entityName} - {item.itemNameSuffix}
            </>
          ) : (
            item.entityName
          )}
        </Tag>
        {item.isCurrent ? null : (
          <Tag intent="warning" icon="warning-sign">
            Not a current item
          </Tag>
        )}
        {item.isCurrent ? null : (
          <Tag intent="warning" icon="warning-sign">
            Not a current item
          </Tag>
        )}
        {this.renderAgainstItem(item)}
        <Button
          intent="danger"
          text="Remove"
          icon="trash"
          outlined
          onClick={() => {
            let ii = this.props.data.itemsNeededForSurgery;
            ii.splice(index, 1);
            this.props.onUpdate({ itemsNeededForSurgery: ii });
          }}
        />
      </ControlGroup>
    );
  };
  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          <Card elevation={Elevation.FOUR} style={{ marginBottom: "10px" }}>
            <Tag large intent="primary">
              Surgery Items
            </Tag>
            <Tag large minimal>
              EntityName :{" "}
              {this.props.data.itemsNeededForSurgery
                .map((each) => each.entityName)
                .join(", ")}
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>{" "}
        </Collapse>
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Items Needed For Surgery
              </Tag>{" "}
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <br />
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              {this.renderItemSearch()}
              {this.renderAddedItems()}
            </div>
          </Card>
        </Collapse>
      </>
    );
  };

  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SxItems)));
